import { render, staticRenderFns } from "./SvgTalk.vue?vue&type=template&id=38202720&"
import script from "./SvgTalk.vue?vue&type=script&lang=js&"
export * from "./SvgTalk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports